module.exports = __webpack_public_path__ + "img/patreon-dark.cd84886f.svg";